import React, { useState } from "react";
import FormField from "../../../FormField";
import useProjectStore from '../../../../store-zustand/project';

const ProjectDescription = ({ description }) => {
  const { setcurrentAnnotationDescription, currentAnnotationDescription } = useProjectStore();
  const [descriptionValue, setDescription] = useState(currentAnnotationDescription);

  const handleDescription = (e) => {
    setDescription(e.target.value);
    setcurrentAnnotationDescription(e.target.value);
  };

  return (
    <FormField label="Description" id="project_description">
      <textarea id="project_description" rows="4" placeholder="Enter description" value={descriptionValue} onChange={handleDescription} />
    </FormField>
  );
};

export default ProjectDescription;